import React, { useState } from 'react';
import moment from 'moment';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  Header, Title, ModificaButton, CompactSummary, InfoList, InfoRow,
} from './VehicleSummaryCard.styles';
import editIcon from '../../../../../assets/redesign_icons/edit-icon.svg';

function InfortunioSummaryCard({ customer, insuranceRequest, modifyData }) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const residenza = `${insuranceRequest.customer.province.name}, ${insuranceRequest.customer.province.car_plate_symbol}`;
  const indirizzo = `${insuranceRequest.customer.address}, ${insuranceRequest.customer.house_number}`;

  return (
    <Card>
      <Header>
        <Title>Infortunio</Title>
        {modifyData && (
          <ModificaButton type="button" onClick={() => modifyData()}>
            Modifica Dati
            <img src={editIcon} alt="" />
          </ModificaButton>
        )}
      </Header>

      <CompactSummary>
        {customer.name}
        {' '}
        {customer.surname}
      </CompactSummary>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi dettagli"
          closedLabel="Dettagli"
        >
          <InfoList>
            <InfoRow>
              <dt>Contraente</dt>
              <dd>
                {customer.name}
                {' '}
                {customer.surname}
              </dd>
            </InfoRow>
            <InfoRow>
              <dt>Residenza</dt>
              <dd>{residenza}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Indirizzo</dt>
              <dd>{indirizzo}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Componenti Nucleo Famigliare</dt>
              <dd>{customer.family_household_members}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Inizio Copertura</dt>
              <dd>{moment(insuranceRequest.policy_effective_date).format('DD-MM-YYYY')}</dd>
            </InfoRow>
          </InfoList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default InfortunioSummaryCard;
